<template>
  <v-jumbotron>
    <v-container fill-height>
      <v-layout align-center>
        <v-flex>
          <h4 class="display-1 my-3">
            Transmitting submission...
          </h4>
          <span class="subheading">
            <p>Submissions are evaluated in the order they are received, typically within a few hours. We recommend checking your submission status now to make sure it is in the queue for evaluation (and hasn't already errored out due to a malformed input, inaccessible container, etc). </p>
            <p>You can check the status of your submissions at any time, using the "My Submissions" link in the toolbar at top right. </p>
          </span>
          <span class="subheading">
            <!-- <p class='mt-3'>Check submissions: <v-btn flat color="primary" to="submissions">My submissions</v-btn></p> -->
          </span>
          <v-btn color="primary" to="submissions">My submissions</v-btn>

        </v-flex>
      </v-layout>
    </v-container>
  </v-jumbotron>

</template>

<script>
  export default {
    name: 'SubmissionConfirmed',
    data () {
      return {
        // gradient: '315deg, #3f87a6, #f69d3c',
      }
    },
    mounted () {
      // console.log('SubmissionConfirmed component mounted')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Challenge/SubmissionConfirmed.vue